import {Component, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {GroupParticipantCreate} from "./group-participant-create";
import {StudentAutocompleteAdapter} from "../../person-autocomplete/person-autocomplete-adapters";
import {ActivatedRoute} from "@angular/router";
import {Adapter} from "../../person-autocomplete/person-autocomplete.component";
import {Observable} from "rxjs";
import {V3GroupStudent, V3Student} from "../../../model/v3/schools";
import {StudentV3RestService} from "../../../services/rest/v3/student-rest.service";
import {V3Person, V3PersonDetails} from "../../../model/v3/people";
import {ManagerUtils} from "../../../services/utils/v3/manager-utils";
import {GroupV3RestService} from "../../../services/rest/v3/group-rest.service";
import {formatDate} from "@angular/common";

@Component({
    selector: 'app-group-student-create',
    templateUrl: './group-participant-create.component.html',
    styleUrls: ['./group-participant-create.component.scss'],
    standalone: false
})
export class GroupStudentCreateComponent extends GroupParticipantCreate<V3Student> implements OnInit {

  participant = {} as V3GroupStudent
  participantAdapter: Adapter<V3Student>;

  constructor(activatedRoute: ActivatedRoute,
              groupV3Rest: GroupV3RestService,
              studentV3Rest: StudentV3RestService,
              @Inject(LOCALE_ID) private locale: string
  ) {
    super(activatedRoute, groupV3Rest, studentV3Rest, null)
  }

  ngOnInit(): void {
  }

  setupAutocompleteAdapters() {
    this.participantAdapter = new StudentAutocompleteAdapter(this.schoolId, this.studentV3Rest);
  }

  participantSelected(student: V3GroupStudent, selectedStudent: V3Student) {
    this.isParticipantSelected = true
    this.participant = JSON.parse(JSON.stringify(student)) as V3GroupStudent
    this.participant.member = JSON.parse(JSON.stringify(selectedStudent)) as V3Student
    this.participant.member.person.details.name = ManagerUtils.getName(selectedStudent.person);
    if (this.participant.from)
      this.participant.from = formatDate(this.participant.from, "yyyy-MM-dd", this.locale) as unknown as number;
    if (this.participant.to)
    this.participant.to = formatDate(this.participant.to, "yyyy-MM-dd", this.locale) as unknown as number;
  }

  addParticipant() {
    this.isParticipantBeingAdded = true
    this.resetParticipantObject()
  }
  resetParticipantObject() {
    this.unlinkParticipant()
    this.groupParticipantForm.resetForm()
    this.isParticipantSelected = false
    this.participant = {} as V3GroupStudent;
    this.participant.member = {} as V3Student
    this.participant.member.person = {} as V3Person
    this.participant.member.person.details = {} as V3PersonDetails
    this.participant.member.person.details.name = ""
  }

  saveParticipant() {
    this.participant.labels = this.labels?.split(',')
    let observable: Observable<any>
    if(!this.isParticipantBeingEdited)
      observable = this.groupV3Rest.addGroupStudent(this.schoolId, this.groupId, this.participant)
    else
      observable = this.groupV3Rest.updateMemberDetails(this.schoolId, this.groupId, this.participant.id, this.participant)

    observable.subscribe(_ => {
      this.isParticipantBeingAdded = false
      this.isParticipantBeingEdited = false
      this.reloadGroupEmitter.emit()
    })
    this.resetParticipantObject()
  }
}
